import { AriaAttributes } from 'react';

export const FORM_FIELD_ERROR_ARIA_LIVE_VALUE: AriaAttributes['aria-live'] =
  'polite';
